import FEATURES from 'global/features';
import { routePaths } from 'global/routePaths';

interface ICompanySettingsData {
  label: string;
  path: string;
  isVisible: boolean;
  isBeta: boolean;
  isNew?: boolean;
}

export const companySettingsData = (featureList: any, companyInfo: any): ICompanySettingsData[] => {
  return [
    {
      label: 'General',
      path: routePaths.companySettings.general,
      isVisible: true,
      isBeta: false,
    },
    {
      label: 'Notifications',
      path: routePaths.companySettings.notifications,
      isVisible: true,
      isBeta: false,
    },
    {
      label: 'Payroll & Overtime',
      path: routePaths.companySettings.payrollAndOvertime.base.route,
      isVisible: true,
      isBeta: false,
    },
    {
      label: 'Schedule',
      path: routePaths.companySettings.schedule,
      isVisible: featureList[FEATURES.scheduling],
      isBeta: false,
    },
    {
      label: 'Reports',
      path: routePaths.companySettings.report,
      isVisible: true,
      isBeta: false,
    },
    {
      label: 'Breaks',
      path: routePaths.companySettings.breaks,
      isVisible: companyInfo?.allowManualBreak,
      isBeta: false,
    },
    {
      label: 'Time Rounding',
      path: routePaths.companySettings.timeRounding,
      isVisible: true,
      isBeta: false,
    },
    {
      label: 'Audit Logs',
      path: routePaths.companySettings.auditLogs,
      isVisible: true,
      isBeta: false,
    },
    {
      label: 'California Breaks',
      path: routePaths.companySettings.californiaBreaks.base.route,
      isVisible: featureList[FEATURES.cali_break_policy],
      isBeta: false,
    },
    // {
    //   label: 'Timeero Terminal (kiosk app) ',
    //   path: routePaths.companySettings.facialRecognition,
    // },
    {
      label: 'Suggested Mileage',
      path: routePaths.companySettings.shortestDistance,
      // isVisible: featureList[FEATURES.suggested_mileage],
      isVisible: false,
      isBeta: false,
    },
    {
      label: 'Segmented Tracking',
      path: routePaths.companySettings.segmentedTracking,
      isVisible: featureList[FEATURES.segmented_tracking],
      isBeta: false,
    },
    {
      label: 'Signatures',
      path: routePaths.companySettings.signatures,
      isVisible: featureList[FEATURES.time_signatures],
      isBeta: false,
    },
    {
      label: 'Tracker Checklist',
      path: routePaths.companySettings.trackerChecklist,
      isVisible: true,
      isBeta: false,
    },
    {
      label: 'Time Off Setup',
      path: routePaths.companySettings.timeOffSetup,
      isVisible: featureList[FEATURES.time_off],
      isBeta: false,
      isNew: true,
    },
    {
      label: 'Commute Mileage',
      path: routePaths.companySettings.commuterMileage,
      isVisible: featureList[FEATURES.commuter_mileage],
      isBeta: false,
    },
    {
      label: 'EVV Settings',
      path: routePaths.companySettings.evvSettings,
      isVisible: companyInfo?.evvSetting?.has_evv,
      isBeta: false,
    },
    {
      label: 'Custom Fields',
      path: routePaths.companySettings.customFields.base,
      isVisible: featureList[FEATURES.custom_fields],
      isBeta: false,
    },
  ];
};
